export const LIDO_ABI = [
    {
        constant: false,
        inputs: [{ name: '_referral', type: 'address' }],
        name: 'submit',
        outputs: [{ name: '', type: 'uint256' }],
        payable: true,
        stateMutability: 'payable',
        type: 'function',
    },
];
export const LIDO_ADDRESS = '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84';
